var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveNavbar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 6,
    viewBox: "0 0 138 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0H132C135.314 0 138 2.68629 138 6H0Z",
    fill: "#134F98"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveNavbar);
export default __webpack_public_path__ + "static/media/ActiveNavbar.578fa0649068e7f346349cdeab96afb6.svg";
export { ForwardRef as ReactComponent };